import React, { useState, useEffect } from 'react';
import { IntlProvider } from 'react-intl';
import { withCookies } from 'react-cookie';
import { getLanguage, storeLanguage } from '../utils/i18n';
import LocaleContext from '../contexts/localeContext';

function I18nProvider({ children, loadMessages, defaultLanguage, cookies }) {
  const initLocale = getLanguage(cookies, defaultLanguage);

  const [locale, setLocale] = useState(initLocale);
  const [firstInit, setFirstInit] = useState(true);
  const [messages, setMessages] = useState(null);

  useEffect(
    () => {
      setMessages(loadMessages(locale));

      if (!firstInit) {
        storeLanguage(cookies, locale, defaultLanguage);
      } else {
        setFirstInit(false);
      }
    },
    [locale]
  );

  const changeLocale = newLocale => {
    setLocale(newLocale);
  };

  return messages ? (
    <LocaleContext.Provider value={{ localeContext: { changeLocale } }}>
      <IntlProvider locale={locale} messages={messages}>
        {children}
      </IntlProvider>
    </LocaleContext.Provider>
  ) : null;
}

export default withCookies(I18nProvider);
